import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "pdl-10 pdr-10 mt-30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Latest Monthly Member Work History Reports", -1)
const _hoisted_3 = { class: "bordered-card bordered-card_secondary bg-light-green mb-30 flex-column flex-md-row gap-30" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "pdr-20" }, " Latest Report ", -1)
const _hoisted_5 = { class: "d-flex gap-5 fs-sm align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-pdf d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" })
], -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "divider divider_vertical divider_vertical_mobile my-0"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Member Work History", -1)
const _hoisted_10 = { class: "d-flex flex-column gap-20 mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_HistoryFilters = _resolveComponent("HistoryFilters")!
  const _component_HistoryResults = _resolveComponent("HistoryResults")!

  return ($setup.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries($setup.reports).reverse(), (report, key, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", {
                  class: "plan-modal",
                  onClick: _withModifiers(($event: any) => ($setup.openModal('smartsearch', null, 'modal-success', null, { DocumentID: report[0] })), ["prevent"])
                }, _toDisplayString(report[1]), 9, _hoisted_7)
              ]),
              (index < Object.entries($setup.reports).length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _hoisted_9,
        _createVNode(_component_MessageCard, {
          message: $setup.instructions,
          type: "primary",
          iconClass: "iatse-icon-alarm",
          classes: "info_card__page"
        }, null, 8, ["message"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_HistoryFilters, {
            loadingSearch: $setup.loadingSearch,
            "onUpdate:loadingSearch": _cache[0] || (_cache[0] = ($event: any) => (($setup.loadingSearch) = $event)),
            reset: $setup.reset,
            onSearch: $setup.searchData,
            errors: $setup.errors
          }, null, 8, ["loadingSearch", "reset", "onSearch", "errors"])
        ]),
        ((!$setup.loading))
          ? (_openBlock(), _createBlock(_component_HistoryResults, {
              key: 0,
              loading: $setup.loadingSearch,
              loadingTotals: $setup.loadingTotals,
              "onUpdate:loadingTotals": _cache[1] || (_cache[1] = ($event: any) => (($setup.loadingTotals) = $event)),
              pageChanged: $setup.pageChanged,
              onResetFilters: $setup.resetFilters,
              onFetchPaginationData: $setup.fetchPaginationData
            }, null, 8, ["loading", "loadingTotals", "pageChanged", "onResetFilters", "onFetchPaginationData"]))
          : _createCommentVNode("", true)
      ]))
}